import React from "react";
import PropTypes from "prop-types";
import Dialog from "./Dialog"
import { convertMinutesToText } from "../../lib/utils";

export default function ConversionsDialog({ open, cancel,  conversionsBefore, email}) {
  return (
    <Dialog
      open={open}
      cancel={cancel}
      message={(<span>There are other products waiting to be uploaded. <br />
        Your conversion will start in about <b>{convertMinutesToText(conversionsBefore * 8)}</b>. <br />
        We will notify you when the process is complete at this address <b>{email}</b>.</span>)}
      cancelText="Close"
      innerTitle="We are a bit busy right now"
    />
  );
}

Dialog.propTypes = {
  open: PropTypes.bool,
  cancel: PropTypes.func,
  conversionsBefore: PropTypes.number,
  email: PropTypes.string
};

Dialog.defaultProps = {
  open: undefined,
  title: '',
  conversionsBefore: 0,
  email: '',
};



// WEBPACK FOOTER //
// ./src/components/Dialog/ConversionsDialog.js